import { Helper } from 'apps/orion/src/app/helper/helper';

/** Keys and names the goods-receipts list is stored and exported under. */
export const GOODS_RECEIPTS_LIST = {
  baseModule: Helper.GOODRECEIPTS_MODULE,
  cachedModule: Helper.FINANCIAL_MODULE,
  columnVisibilityKey: 'column_list-goodreceipts',
  downloadFailed: 'financialModule.downloadError',
  fieldsKey: 'GOODRECEIPTS_MODULE_FORMKEY',
  fileName: 'gr',
} as const;
